import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class MemberPointTransaction extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            userid: user_id,
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            add_members: [],
            add_member_id: [],
            addIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            warningIsOpen: false,
            content_id: '',
            warningMessage: "",
            methodOpen: '',
            add_id: '',
            add_name: '',
            src_name_th: '',
            src_name_en: '',
            src_name: '',
            src_phone: '',
            add_type: '',
            add_active_status: '',
            add_img: '',
            add_point: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            file: null,
            spinner: true,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            //new ui
            ismember_search: false, 
            src_idcard: "",
            member_username: "",
            member_name: "",
            member_idcard: "",
            member_phone: "",
            member_line: "",
            member_email: "",
            addPointError: false,
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.dataMember = this.dataMember.bind(this);
        
        this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.closeWarning = this.closeWarning.bind(this);
        this.onTagsChange = this.onTagsChange.bind(this);
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.clearSearchMember = this.clearSearchMember.bind(this);
        this.submitMemberSearch = this.submitMemberSearch.bind(this);

        
        this.dataTable();
        this.dataMember();
    }

    clearSearchMember = () => {
        this.setState({
            ismember_search: false, 
            src_idcard: "",
            member_username: "",
            member_name: "",
            member_idcard: "",
            member_phone: "",
            member_line: "",
            member_email: "",
            add_member_id: "",
            addPointError: false
        })
    }

    submitMemberSearch = () => {
        try {

            if(!this.state.src_idcard){
                alert('กรุณากรอก เลขบัตรประชาชนของเจ้าบ้าน')
                return
            }

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };

            const query = `?idcard=${this.state.src_idcard}`

            fetch(config.url.API_URL + '/members/' + query, requestOptions)
                .then(res => res.json())
                .then(data => {
                    const reponse = data;
                    if(reponse.status === 'Success'){
                        const member = reponse.data[0]
                        this.setState({
                            ismember_search: true, 
                            member_username: member.username ? member.username : "",
                            member_name: member.member_name ? member.member_name : "",
                            member_idcard: member.idcard ? member.idcard : "",
                            member_phone: member.phone ? member.phone : "",
                            member_line: member.line_id ? member.line_id : "",
                            member_email: member.email ?  member.email : "",
                            add_member_id: member.id ? member.id : ""
                        })
                    }else{
                        alert("ไม่พบข้อมูลในระบบ")
                        this.clearSearchMember()
                    }
                }).catch(error => {
                    console.log(error)
                    alert("ไม่พบข้อมูลในระบบ")
                    this.clearSearchMember()
                }) 

        } catch (error) {
            console.log(error)
            alert("ไม่พบข้อมูลในระบบ")
            this.clearSearchMember()
        }
    }

    handleChangeNumber = (event) => {
        let { value } = event.target;
        value = value.replace(/\D/g,''); // Remove all non-digit characters
        if (value === '') {
          this.setState({ [event.target.name]: '' });
        } else {
          this.setState({ [event.target.name]: parseInt(value).toLocaleString() });
        }
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    onTagsChange = (event, values) => {
        if (values != null) {
            this.setState({
                add_member_id: values.value
            });
        }
    }

    dataMember() {
        try {
            let project_id = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            //let body = `?user_type=owner,install`
            // let body = `?user_type=owner`
            let body = `?user_type=owner&sortBy=name`
            fetch(config.url.API_URL + '/members/' + body, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data
                    let FromApi = data.map(data => {
                        return { value: data.id, display: data.member_name }
                    });
    
                    this.setState({
                        add_members: [].concat(FromApi)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            this.setState({spinner:true})
    
            let body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&name_th=${this.state.src_name_th}&name_en=${this.state.src_name_en}&name=${this.state.src_name}&phone=${this.state.src_phone}`
            fetch(config.url.API_URL + '/pointtransactions' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data),
                            spinner: false
                        });
    
                    } else {
                        this.setState({
                            pages: [],
                            spinner: false
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
        }
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_name: '',
            add_point: '',
            add_active_status: true
        });
    }

    openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/pointtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data._id,
                        add_member_id: data.member_id,
                        add_member_name: data.firstname + " " + data.lastname,
                        add_point: data.point ? helpers.formatNumber(data.point) : "",
                        active: data.active_status,
                        ismember_search: true,
                                                member_username: data.username,
                        member_name: `${data.firstname +" "+ data.lastname}` ,
                        member_idcard: data.idcard,
                        member_phone: data.phone,
                        member_email: data.email,
                        member_line_id: data.line_id,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page 
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            this.setState({spinner:true})
    
            fetch(config.url.API_URL + '/pointtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        spinner: false,
                        add_id: data._id,
                        add_member_id: data.member_id,
                        add_member_name: data.firstname + " " + data.lastname,
                        add_point: data.point ? helpers.formatNumber(data.point) : "",
                        add_active_status: data.active_status,
                        ismember_search: true,
                        // src_idcard: data.idcard,
                        member_username: data.username,
                        member_name: `${data.firstname +" "+ data.lastname}` ,
                        member_idcard: data.idcard,
                        member_phone: data.phone,
                        member_email: data.email,
                        member_line_id: data.line_id,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view',
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeWarning() {
        this.setState({ warningIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: '',
            add_name: '',
            add_point: '',
            file: null
        });
        this.setState({ addIsOpen: false });
        this.clearSearchMember()
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            src_name: '',
            src_phone: '',
            add_name: '',
            add_point: '',
            page: 0
        });
    }

    submitAdd() {
        try {
            
        if(!this.state.add_member_id || this.state.add_member_id.length === 0){
            alert('ไม่พบข้อมูล สมาชิก')
            return
        }

        if(!this.state.add_point){
            this.setState({ addPointError: true });
            alert('ไม่พบข้อมูล Point')
            return
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
            body: JSON.stringify({
                member_id: this.state.add_member_id,
                point: this.state.add_point ? helpers.removeFormatNumber(this.state.add_point) : "",
                active_status: this.state.active ? 1 : 0,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id
            }),
        };
        this.setState({spinner:true})
        fetch(config.url.API_URL + '/pointtransactions', requestOptions)
            .then(res => res.json())
            .then(data => {
                if (data.message) {
                    this.setState({
                        spinner: false,
                        updateIsOpen: false,
                        warningIsOpen: true,
                        warningMessage: data.message,
                        file: null,
                        spinner: false
                    });
                } else {
                    this.setState({
                        updateIsOpen: true,
                        spinner: false
                    });
                }
            }).catch(error => {
                console.log(error)
                //window.location.reload(); // Reload the page
            })

        this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'DELETE',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/pointtransactions/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitEdit(e) {
        try {
            if(!this.state.add_member_id || this.state.add_member_id.length === 0){
                alert('ไม่พบข้อมูล สมาชิก')
                return
            }
    
            if(!this.state.add_point){
                alert('ไม่พบข้อมูล Point')
                return
            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    member_id: this.state.add_member_id,
                    point: this.state.add_point ? helpers.removeFormatNumber(this.state.add_point) : "",
                    active_status: this.state.active ? 1 : 0,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
            this.setState({spinner: true})
            fetch(config.url.API_URL + '/pointtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        spinner: false,
                        updateIsOpen: true,
                        addIsOpen: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">รายการเพิ่มแต้มให้สมาชิก</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">เพิ่มแต้มให้สมาชิก</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="member_points" element={(this.state.user_permission[225].permission == 1 &&
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="member_points">
                                            <ExcelColumn label="ชื่อ-สกุล" value={(col) => col.firstname + " " + col.lastname} />
                                            <ExcelColumn label="เบอร์โทรศัพท์" value={(col) => col.phone} />
                                            <ExcelColumn label="แต้ม" value={(col) => col.point} />
                                            <ExcelColumn label="สถานะ" value={(col) => col.reject_status == 1 ? "ไม่อนุมัติ":col.approve_status == 1 ? "อนุมัติแล้ว":"รอการอนุมัติ"} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updated ? moment(col.updated).format('DD/MM/YYYY HH:mm น.') : moment(col.created).format('DD/MM/YYYY HH:mm น.')} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {(this.state.user_permission[24].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ-สกุล</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>เบอร์โทรศัพท์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Point</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    {/* <StyledTableCell>{i+1}</StyledTableCell> */}
                                                                    <StyledTableCell>{i + (this.state.page * this.state.rowsPerPage) + 1  }</StyledTableCell>
                                                                    <StyledTableCell>{data.firstname + " " + data.lastname}</StyledTableCell>
                                                                    <StyledTableCell>{data.phone}</StyledTableCell>
                                                                    <StyledTableCell>{data.point ? helpers.formatNumber(data.point) : ""}</StyledTableCell>
                                                                    <StyledTableCell>{(data.reject_status == 1 ? "ไม่อนุมัติ":data.approve_status == 1 ? "อนุมัติแล้ว":"รอการอนุมัติ")}</StyledTableCell>
                                                                    <StyledTableCell>{data.updated ? moment(data.updated).format('DD/MM/YYYY HH:mm น.') : moment(data.created).format('DD/MM/YYYY HH:mm น.')}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data._id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[25].permission == 1 && data.approve_status == 0 && data.reject_status == 0) &&
                                                                            <button className="btn-action text-center" data-id={data._id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        }
                                                                        {(this.state.user_permission[26].permission == 1 && data.approve_status == 0 && data.reject_status == 0) &&
                                                                            <button className="btn-action text-center" data-id={data._id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        }
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>}
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name" name="src_name" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทรศัพท์</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_phone" name="src_phone" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div> */}
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="lg">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-control">
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">เลขบัตรประชาชนของเจ้าบ้าน<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                {(this.state.methodOpen === 'add') ?
                                        (<input type="text" 
                                            className="form-control" 
                                            id="src_idcard" 
                                            name="src_idcard" 
                                            placeholder='กรอกเลขบัตรประชาชน 13 หลัก'
                                            maxLength="13"
                                            value={this.state.src_idcard} 
                                            onChange={this.change}
                                            onKeyPress={(event) => {
                                            const keyCode = event.which ? event.which : event.keyCode;
                                            const keyValue = String.fromCharCode(keyCode);
                                                if (!/^\d+$/.test(keyValue)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                         />)
                                : (<div className="form-control">{this.state.member_idcard}</div>)}
                                </div>
                                <div>
                                    <button type='button' className="btn btn-success mx-1" onClick={this.submitMemberSearch}>ค้นหาข้อมูล</button>
                                    <button type='button' className="btn btn-secondary mx-1" onClick={this.clearSearchMember}>ล้างค่า</button>
                                </div>
                            </div><hr/> */}

                            {(this.state.methodOpen === 'add') ?
                                (
                                 <>
                                    <div className="row mb-3">
                                        <div className="col-sm-3 text-right">เลขบัตรประชาชนของเจ้าบ้าน<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-5">
                                                <input type="text" 
                                                    className="form-control" 
                                                    id="src_idcard" 
                                                    name="src_idcard" 
                                                    placeholder='กรอกเลขบัตรประชาชน 13 หลัก'
                                                    maxLength="13"
                                                    value={this.state.src_idcard} 
                                                    onChange={this.change}
                                                    onKeyPress={(event) => {
                                                    const keyCode = event.which ? event.which : event.keyCode;
                                                    const keyValue = String.fromCharCode(keyCode);
                                                        if (!/^\d+$/.test(keyValue)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                 />
                                        </div>
                                        <div>
                                            <button type='button' className="btn btn-success mx-1" onClick={this.submitMemberSearch}>ค้นหาข้อมูล</button>
                                            <button type='button' className="btn btn-secondary mx-1" onClick={this.clearSearchMember}>ล้างค่า</button>
                                        </div>
                                    </div><hr/>
                                 </>   
                                    ) : (<></>)}

                            {
                                !this.state.ismember_search && <div style={{ textAlign: 'center' }}></div>
                            }
                            {
                                this.state.ismember_search &&
                                <>
                                    <div className='row mb-3 align-center' >
                                    <div className='col-sm-3 text-right'>Username</div>
                                    <div className='col-sm-5'>
                                        <div className="form-control">{this.state.member_username} </div>
                                    </div>
                                    </div>
                                    <div className='row mb-3 align-center'>
                                        <div className='col-sm-3 text-right'>ชื่อ</div>
                                        <div className='col-sm-5'>
                                            <div className="form-control">{this.state.member_name} </div>
                                        </div>
                                    </div>
                                    <div className='row mb-3 align-center'>
                                        <div className='col-sm-3 text-right'>รหัสบัตรประจำตัวประชาชน</div>
                                        <div className='col-sm-5'>
                                            <div className="form-control">{this.state.member_idcard} </div>
                                        </div>
                                    </div>
                                    <div className='row mb-3 align-center'>
                                        <div className='col-sm-3 text-right'>เบอร์โทรศัพท์</div>
                                        <div className='col-sm-5'>
                                            <div className="form-control">{this.state.member_phone} </div>
                                        </div>
                                    </div>
                                    <div className='row mb-3 align-center'>
                                        <div className='col-sm-3 text-right'>Line</div>
                                        <div className='col-sm-5'>
                                            <div className="form-control">{this.state.member_line}</div>
                                        </div>
                                    </div>
                                    <div className='row mb-3 align-center'>
                                        <div className='col-sm-3 text-right'>อีเมล์</div>
                                        <div className='col-sm-5'>
                                            <div className="form-control">{this.state.member_email}</div>
                                        </div>
                                    </div>


                                    {/* <div className="row mb-3">
                                        <div className="col-sm-3 text-right">สมาชิก<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-5">
                                            {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                                (<Autocomplete
                                                    name="add_member_id"
                                                    defaultValue={this.state.add_members.find(v => v.value == this.state.add_member_id)} 
                                                    options={this.state.add_members}
                                                    autoHighlight
                                                    getOptionLabel={(option) => option.display}
                                                    renderInput={(params) => <TextField
                                                        {...params}
                                                        label=""
                                                        variant="outlined"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            style: { fontSize: 20, fontFamily: "db_heaventmed_cond" }
                                                        }}
                                                        size="small"
                                                    />}
                                                    onChange={this.onTagsChange} />)
                                                : (<div className="form-control">{this.state.add_member_name}</div>)}
                                        </div>
                                    </div> */}

                                    <hr/>
                                </>
                            }
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">Point<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" 
                                        className={`form-control ${this.state.addPointError ? 'error' : ''}`} 
                                        id="add_point" 
                                        name="add_point" 
                                        value={this.state.add_point} 
                                        onChange={this.handleChangeNumber}
                                        placeholder='กรุณากรอกคะแนน'
                                        onKeyPress={(event) => {
                                        const keyCode = event.which ? event.which : event.keyCode;
                                        const keyValue = String.fromCharCode(keyCode);
                                        if (!/^\d+$/.test(keyValue)) {
                                            event.preventDefault();
                                        }
                                        }}
                                         />)
                                        : (<div className="form-control">{this.state.add_point}</div>)}
                                </div>
                            </div>
                            
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.warningIsOpen} onHide={this.closeWarning} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        เพิ่มข้อมูลสำเร็จ
                        {/* {this.state.warningMessage} */}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeWarning}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}